import React, { Component } from 'react';
import ReactQuill from 'react-quill-new'; 
import 'react-quill-new/dist/quill.snow.css'; 
import { TwModal } from '@ui-component-library';
import VBTextarea from '@vb-js-commons/new/vbTextarea';
import * as Opt from '../Helpers';


const Quill = ReactQuill.Quill



class TextEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTextEdit:false,
      text: this.props.value, 
    };
  }

  handleSave(){
    this.props.onChange(this.state.text.replaceAll("&nbsp;", " "))
  }

  handleEdit(text){
    this.setState({text:text})
  }

  
  render() {
    return (
      <>
      <TwModal isOpen={this.state.showTextEdit} className="bg-white p-2">
        <TwModal.Header>
            <div className="flex justify-between items-start">
                <span>Edit text</span>
                <button type="button" className="ml-auto fs-5 leading-none" onClick={() => this.setState({ showTextEdit: false })} aria-label="Close">&times;</button>
            </div>
        </TwModal.Header>
        <TwModal.Content>
          {<ReactQuill
            theme="snow"
            value={this.state.text}
            onChange={this.handleEdit.bind(this)}
            modules={{
              toolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote'],
                ['link'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ color: Opt.colorHex.map((itm)=>itm.value)}, { background: Opt.colorHex.map((itm)=>itm.value) }],
                [{ align: [] }],
              ],
            }}
          /> }
        </TwModal.Content>
        <TwModal.Footer>
            <div className='flex justify-between'>
              <button className='n-btn btn-sm btn-outline btn-charcoal' onClick={() => { this.setState({ showTextEdit: false }) }}>Cancel</button>
              <button className='n-btn btn-sm btn-forest-green' onClick={() => { this.setState({ showTextEdit: false }); this.handleSave() }}>Save</button>
            </div>
        </TwModal.Footer>
      </TwModal>
      <button className="_Button_1brfa_1 _Button--secondary_1brfa_53 _Button--medium_1brfa_22" onClick={() => {this.setState({showTextEdit: true})}}>Edit text</button>
      </>
    );
  }
}
TextEditor.defaultProps={
    value:"Lorem ipsum dolor sit amet.",
    text:"Lorem ipsum dolor sit amet.",
    color:"primary-dark"
}

export default TextEditor;